import { BReactComponent } from 'blocks-cloud/b-react-component';
import { renderWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { isDialogVisible } from 'reactApp/modules/dialog/dialog.selectors';
import { hidePromo, initPromoController } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { store } from 'reactApp/store';
import { TopBanner } from 'reactApp/ui/TopBanner/TopBanner';
import { ITopBannerProps } from 'reactApp/ui/TopBanner/withRequiredHtmlContentHOC';

let showingBanner;
let reactBanner;
let isPromoDialogShown = false;

function showPromoBanner(promo) {
    if (!promo || reactBanner) {
        return;
    }

    const root = document.querySelector('#topBanner');

    if (!root) {
        return;
    }

    reactBanner = new BReactComponent({
        ReactComponent: TopBanner,
        renderMode: 'append',
    });

    const props: ITopBannerProps = {
        closeDarkTheme: promo.closeColor === 'color_dark',
        htmlContent: promo.html,
        onShow: () => promo.onShow(),
        onClose: () => {
            promo.onClose();
            store.dispatch(hidePromo());
            setTimeout(() => {
                reactBanner?.destroy();
                reactBanner = null;
            }, 100); //  чтобы событие close успело уйти
        },
        onClick: () => {
            promo.onClick();
            store.dispatch(hidePromo());
            setTimeout(() => {
                reactBanner?.destroy();
                reactBanner = null;
            }, 100); //  чтобы событие click успело уйти
        },
    };

    reactBanner.renderTo(root, {
        props,
    });

    showingBanner = promo.promoId;
}

export default () => {
    store.subscribe(() => {
        const state = store.getState();

        const promo = PromoSelectors.getCurrentPromo(state);
        const isAnyDialogShown = isDialogVisible(state);
        const isViewerOpening = ViewerSelectors.isViewerOpening(state);
        const isViewerActive = ViewerSelectors.isViewerActive(state);

        switch (promo?.type) {
            case EPromoType.topBanner: {
                showPromoBanner(promo?.data);
                break;
            }
            case EPromoType.whatsNew:
                if (!isPromoDialogShown && !isAnyDialogShown && !isViewerActive && !isViewerOpening) {
                    isPromoDialogShown = true;
                    renderWhatsNewDialog({
                        ...promo?.data,
                        onClose: () => {
                            promo?.data?.onClose();
                            store.dispatch(hidePromo());
                            isPromoDialogShown = false;
                        },
                    });
                }
                break;
        }
    });

    setTimeout(() => store.dispatch(initPromoController()), 1000);
};

export const whatIsShowingBanner = () => showingBanner;
